import React, { Component } from 'react'

import Button from '../UI/Button/Button';

import classes from './NoInternet.module.css'

class NoInternet extends Component {
    componentDidMount() {
        setTimeout(function () {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }, 1);
    }

    shouldComponentUpdate() {
        return false;
    }

    onRefreshClick = () => {
        document.location.reload()
    }

    render() {
        return (
            <div className={classes.NoInternet}>
                <div className={classes.NoInternetIcon}>
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100px" height="100px" viewBox="0 0 499.943 499.943" fill="rgba(0, 150, 255, 0.5)">
                        <g>
                            <path d="M179.39,230.895c-22.979,0-41.606,18.618-41.606,41.607V393.85c0,22.969,18.628,41.605,41.606,41.605h6.196
                                c22.979,0,41.606-18.627,41.606-41.605V272.502c0-22.979-18.627-41.607-41.606-41.607H179.39L179.39,230.895z"/>
                            <path d="M315.761,435.455h6.196c22.979,0,41.606-18.627,41.606-41.605V203.154c0-22.969-18.628-41.606-41.606-41.606h-6.196
                                c-22.979,0-41.606,18.628-41.606,41.606V393.85C274.164,416.818,292.791,435.455,315.761,435.455z"/>
                            <path d="M458.337,64.479h-6.206c-22.969,0-41.597,18.627-41.597,41.606v287.774c0,22.969,18.628,41.605,41.597,41.605h6.206
                                c22.979,0,41.606-18.627,41.606-41.605V106.075C499.943,83.106,481.316,64.479,458.337,64.479z"/>
                            <path d="M99.036,393.85v-71.662c0-22.969-18.638-41.605-41.606-41.605h-6.197c-22.979,0-41.606,18.627-41.606,41.605v71.662
                                c0,22.969,18.637,41.605,41.606,41.605h6.197C80.398,435.455,99.036,416.818,99.036,393.85z"/>
                            <path d="M22.44,233.955l30.992-30.992l30.982,30.992c5.135,5.135,13.454,5.135,18.589,0c5.145-5.135,5.135-13.455,0-18.589
                                l-30.982-30.983l30.982-30.982c5.135-5.135,5.135-13.454,0-18.589s-13.455-5.135-18.589,0l-30.982,30.982L22.44,134.811
                                c-5.135-5.135-13.455-5.135-18.589,0c-5.135,5.135-5.135,13.445,0,18.58l30.992,30.992L3.86,215.365
                                c-5.135,5.135-5.135,13.454,0,18.589C8.986,239.089,17.315,239.089,22.44,233.955z"/>
                        </g>
                    </svg>
                </div>
                <div className={classes.NoWifiIcon}>
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="150px" height="150px" viewBox="0 0 512.006 512.006" fill="rgba(0, 150, 255, 0.5)">
                        <g>
                            <g>
                                <path d="M415.632,412.002L48.699,45.077c-3.328-3.336-8.738-3.336-12.066,0c-3.337,3.337-3.337,8.73,0,12.066l43.196,43.187
                                    c-27.034,12.783-52.267,27.93-74.931,45.414l-1.485,1.135c-1.852,1.391-3.055,3.465-3.345,5.76
                                    c-0.29,2.295,0.367,4.608,1.818,6.409l247.467,307.2c1.621,2.005,4.07,3.183,6.647,3.183c2.586,0,5.026-1.169,6.647-3.183
                                    l81.698-101.41l59.221,59.23c1.664,1.664,3.849,2.5,6.033,2.5c2.185,0,4.369-0.836,6.033-2.5
                                    C418.969,420.732,418.969,415.339,415.632,412.002z"/>
                            </g>
                        </g>
                        <g>
                            <g>
                                <path d="M511.939,152.64c-0.299-2.295-1.51-4.378-3.362-5.768l-1.544-1.178c-33.493-25.796-125.013-85.786-251.034-85.786
                                    c-40.252,0-80.666,6.221-120.107,18.475c-2.85,0.888-5.035,3.2-5.751,6.101c-0.708,2.901,0.137,5.965,2.253,8.081l232.149,232.141
                                    c1.604,1.604,3.772,2.5,6.033,2.5c0.154,0,0.307,0,0.461-0.008c2.415-0.128,4.668-1.28,6.187-3.166l132.898-164.975
                                    C511.572,157.257,512.229,154.935,511.939,152.64z"/>
                            </g>
                        </g>
                    </svg>
                </div>
                <h1 className={classes.Heading}>No Internet Found</h1>
                <p className={classes.SubHeading}>Please try again</p>
                <Button
                    label="RETRY"
                    styleclass="NonMobileOnly"
                    disabled={false}
                    tooltip={null}
                    margin="20px 0px 0px"
                    clicked={this.onRefreshClick}
                />
                <Button
                    label="RETRY"
                    styleclass="MobileOnly"
                    fontSize="0.625em"
                    disabled={false}
                    tooltip={null}
                    margin="20px 0px 0px"
                    clicked={this.onRefreshClick}
                />
            </div>
        );
    }
}

export default NoInternet;